import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 overflow-x-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-4xl font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4 overflow-x"
}
const _hoisted_5 = { class: "w-full overflow-scroll table-auto" }
const _hoisted_6 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_7 = {
  scope: "col",
  class: "w-64 px-2 py-2"
}
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_16 = { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_17 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_18 = { class: "px-2 py-2 capitalize" }
const _hoisted_19 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_20 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_21 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_22 = { class: "px-2 py-2 capitalize" }
const _hoisted_23 = { class: "px-2 py-2 capitalize" }
const _hoisted_24 = { class: "px-2 py-2" }
const _hoisted_25 = { class: "mt-6 overflow-x-auto" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-4xl font-medium capitalize" }
const _hoisted_28 = { class: "text-2xl font-medium" }

import { ref } from "vue";

import TitleHeader from "../TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import OrdersTable from "@/components/tables/OrdersTable.vue";

import api from "@/api/api";
import { Booking, Event } from "@/types";
import { deserializeSlug } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoursesAdminDashboard.vue',
  async setup(__props) {

let __temp: any, __restore: any

const events = ref([] as Event[]);
const orders = ref([] as Booking[]);

async function listEvents() {
  events.value = (
    await api.events.listEvents({
      status: "published",
      page: 1,
      upcoming: true,
    })
  ).data.events;
}

async function listOrders() {
  orders.value = (await api.bookings.listRecentOrders()).data.bookings;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listEvents())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listOrders())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("active-courses-by-play-included")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Training_Events' },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-all-courses")), 1)
          ]),
          _: 1
        })
      ]),
      (events.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("event-name")), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("course-type")), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("venue")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("delivery-date")), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("publish-date")), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("trainer")), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("booked")), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("status")), 1),
                  _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value.splice(0, 3), (event) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x divide-gray-300",
                    key: event.id
                  }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(event.name) + " (#" + _toDisplayString(event.id) + ")", 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(deserializeSlug)(event.type)), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(event.template.delivery !== "in-person" ? "Online" : event.city), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(new Date(event.first_event_date).toDateString()), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(event.publish_at ? new Date(event.publish_at).toDateString() : ""), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(event.owner.first_name) + " " + _toDisplayString(event.owner.last_name), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(event.max_attendees > 0 ? `${event.total_bookings}/${event.max_attendees}` : event.total_bookings), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(event.status), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/courses/events/${event.id}`,
                        class: "text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t("orders")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Orders' },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-all-orders")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t("last-week")), 1),
      _createVNode(OrdersTable, {
        orders: orders.value.splice(0, 7)
      }, null, 8, ["orders"])
    ])
  ], 64))
}
}

})